var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h180v180H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.62 131.824l20.459 21.975c3.351 3.599 9.02 3.701 12.497.223 3.477-3.477 3.376-9.145-.223-12.496l-21.975-20.46-10.758 10.758zm27.299 15.127a.999.999 0 11-1.414 1.414.999.999 0 111.414-1.414z",
    fill: "#0045D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 80c0-27.614-22.386-50-50-50S30 52.386 30 80s22.386 50 50 50a49.774 49.774 0 0029.773-9.827l10.847 11.651 10.758-10.758-11.586-10.787A49.778 49.778 0 00130 80z",
    fill: "url(#empty-search_svg__paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69 78a2 2 0 100-4 2 2 0 000 4zm4.85 6.537c1.684-2.011 3.94-3.037 6.65-3.037 2.71 0 4.966 1.026 6.65 3.037a1.5 1.5 0 11-2.3 1.926C83.743 85.14 82.333 84.5 80.5 84.5c-1.833 0-3.243.641-4.35 1.963a1.5 1.5 0 11-2.3-1.926zM94 76a2 2 0 11-4 0 2 2 0 014 0z",
    fill: "#195DEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-search_svg__paint0_linear",
    x1: -20.689,
    y1: 80.912,
    x2: 81.134,
    y2: 182.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195DEE"
  })))));
}
export default SvgEmptySearch;